module.exports = __webpack_public_path__ + "static/media/profile-picture.0be88361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/profile-picture.jpg
// module id = 54
// module chunks = 0